/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import { onboardingStepSchema } from '../enums/onboarding-step';

export const completeOnboardingStepV1BodySchema = z.object({
  step: onboardingStepSchema,
});

export type ICompleteOnboardingStepV1Body = z.infer<typeof completeOnboardingStepV1BodySchema>;
